import { useEffect } from 'react';

import useAnimatedProgressValue from '../../../../utils/hooks/use-animated-progress-value';
import styles from './circle-animated-progress.module.scss';

const PROGRESS_DURATION_MS = 2000;
const PROGRESS_BAR_RADIUS = 93.5;
const PROGRESS_BAR_LENGTH = 2 * Math.PI * PROGRESS_BAR_RADIUS;

type Props = {
  started?: boolean;
  progressDuration?: number;
  onComplete?: () => void;
  handleStepComplete: (currentIndex: number) => void;
};

const CircleAnimatedProgress = ({
  started = true,
  progressDuration = PROGRESS_DURATION_MS,
  onComplete,
  handleStepComplete,
}: Props) => {
  const progress = useAnimatedProgressValue({
    started,
    progressDuration,
    onComplete,
  });

  useEffect(() => {
    switch (Math.round(progress * 100)) {
      case 20: {
        handleStepComplete(0);
        break;
      }
      case 40: {
        handleStepComplete(1);
        break;
      }
      case 60: {
        handleStepComplete(2);
        break;
      }
      case 80: {
        handleStepComplete(3);
        break;
      }
      case 100: {
        handleStepComplete(4);
        break;
      }
    }
  }, [progress, handleStepComplete]);

  return (
    <div className={styles.progressContainer} role="progressbar">
      <svg
        className={styles.progress}
        viewBox="0 0 199 199"
        xmlns="http://www.w3.org/2000/svg">
        <circle
          cx={99.5}
          cy={99.5}
          className={styles.progressBar}
          r={PROGRESS_BAR_RADIUS}
        />
        <circle
          cx={99.5}
          cy={99.5}
          className={styles.progressValue}
          r={PROGRESS_BAR_RADIUS}
          strokeDasharray={`${
            progress * PROGRESS_BAR_LENGTH
          } ${PROGRESS_BAR_LENGTH}`}
        />
        <defs>
          <linearGradient
            id="gradient-progress"
            x1="-51.8932"
            y1="0.499971"
            x2="124.495"
            y2="12.5818"
            gradientUnits="userSpaceOnUse">
            <stop offset="0.5" stopColor="#FF522C" />
            <stop offset="1" stopColor="#FF3C8B" />
          </linearGradient>
        </defs>
      </svg>
      <h1 className={styles.progressPercentage}>
        {`${Math.round(progress * 100)}%`}
      </h1>
    </div>
  );
};

export default CircleAnimatedProgress;
